import React from 'react';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import './Navbar.css';

function Navbar() {

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);

    };


    const closeMenu = () => {
        setIsMenuOpen(false);
       
    };


    return (
        <>
            <nav>
                <div className="navbar-left">
                    <Link to="/">GladToFindU</Link>
                </div>

                <div className={`navbar-right ${isMenuOpen ? 'mobile-menu' : ''}`}>
                    <div className="navbar-right-exclude-menu">
                        <div className="navbar-right-box"onClick={closeMenu}>
                            <Link to="/">Home</Link>
                        </div>
                        <div className="navbar-right-box" onClick={closeMenu}>
                            <Link to="/services">Map</Link>
                        </div>
                        <div className="navbar-right-box" onClick={closeMenu}>
                            <Link to="/servicetable">Spreadsheet</Link>
                        </div>
                        <div className="navbar-right-box" onClick={closeMenu}>
                            <Link to="/dashboard">Dashboard</Link>
                        </div>
                        <div className="navbar-right-box" onClick={closeMenu}>
                            <Link to="/login">Log in</Link>
                        </div>
                        <div className="navbar-right-box" onClick={closeMenu}>
                            <Link to="/logout">Log out</Link>
                        </div>
                        <div className="navbar-right-box" onClick={closeMenu}>
                            <Link to="/signup">Sign up</Link>
                        </div>
                        <div className="navbar-right-box" onClick={closeMenu}>
                            <Link to="/information">Information</Link>
                        </div >
                    </div>
                    <div>
                        <img src="/icons/icon-navbar.png" className="menu-hamburger" alt="menu hamburger" onClick={toggleMenu}></img>
                    </div>
                </div>
            </nav>


        </>


    );
}

export default Navbar;
